import * as ConnectionsApi from '@bmai/connections-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new ConnectionsApi.Configuration(ApiClientFactory.createConfig('/_connections'));

export const connectionsClient = ApiClientFactory.instantiateApis(ConnectionsApi, configuration);
